import React, { useState, useEffect } from "react";
import "./style.css";
import categ11 from "../../images/categ/categorie1.png";
import categ22 from "../../images/categ/categorie2.png";
import categ33 from "../../images/categ/categorie3.png";
import categ44 from "../../images/categ/categorie4.png";
import { Button } from "@mui/material";
import Footer from "../../Components/Footer";
import Carousel from "../../Components/Carousel";
import ReactGA from "react-ga";
import ScrollPage from "../../Components/scrollpageUp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowRightAltIcon  from '@mui/icons-material/ArrowCircleRight';
import ArrowRightAltIcon2 from '@mui/icons-material/ArrowRightAlt';
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import SelctionSemaine from "../../Components/SelectionSemaine";
import VenteFlash from "../../Components/VenteFlashHome";
import NewHome from "../../Components/NouveauteHome";
import BanniereHome from "../../Components/BanniereHome";
import { useInView } from "framer-motion";
import { useRef } from "react";
import SelectionProduct from "../../Components/SelectionProduct";
import { Skeleton } from "@mui/material";
import slugify from "../../Utils/slugify";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
function Home() {
  const ref1 = useRef(null);
  const ref3 = useRef(null);
  const isInView = useInView(ref1, { once: true });
  const isInView3 = useInView(ref3, { once: true });
const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simule un temps de chargement (ex: 2 secondes)
    // En production, vous mettriez setLoading(false) après vos fetch()
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Fonction pour générer le skeleton du Slider de catégories
  const renderSkeletonCategories = () => (
    <div style={{ display: "flex", gap: "20px", padding: "20px" }}>
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} variant="rectangular" width="25%" height={200} sx={{ borderRadius: "10px" }} />
      ))}
    </div>
  );
  useEffect(() => {
    const updateItemsPerPage2 = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        setItemsPerPage2(4);
      } else if (windowWidth >= 700) {
        setItemsPerPage2(3);
      } else {
        setItemsPerPage2(2);
      }
    };
    updateItemsPerPage2();
    window.addEventListener("resize", updateItemsPerPage2);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage2);
    };
  }, []);
  useEffect(() => {
    const updateItemsPerPage1 = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        setItemsPerPage1(4);
      } else if (windowWidth >= 700) {
        setItemsPerPage1(2);
      } else {
        setItemsPerPage1(2);
      }
    };
    updateItemsPerPage1();
    window.addEventListener("resize", updateItemsPerPage1);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage1);
    };
  }, []);
  const [itemsPerPage1, setItemsPerPage1] = useState(6);
  const [itemsPerPage2, setItemsPerPage2] = useState(4);
  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="custom-arrow custom-next"
        onClick={onClick}
        style={{ border: "1px solid black",marginRight:"5px" }}
      >
        <ArrowRightAltIcon2 fontSize="small" />
      </div>
    );
  };
  const CustomNextArrow3 = ({ onClick }) => {
  return (
    <div className="promo-next-arrow" onClick={onClick}>
      <ArrowRightAltIcon style={{ fontSize: "32px", }} />
    </div>
  );
};

const CustomPrevArrow3 = ({ onClick }) => {
  return (
    <div className="promo-prev-arrow" onClick={onClick}>
      <ArrowRightAltIcon
        style={{ transform: "rotate(180deg)", fontSize: "32px" }}
      />
    </div>
  );
};

  const settings2 = {
    slidesToShow: itemsPerPage2,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    className: "custom-slider",
  };
  const settings1 = {
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    speed: 600,
    slidesToShow: itemsPerPage1,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    className: "custom-slider",
  };
 const settings3 = {
  focusOnSelect: true,
  pauseOnHover: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  fade: false,
  nextArrow: <CustomNextArrow3 />,
  prevArrow: <CustomPrevArrow3 />,
};

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 2500);

    return () => clearTimeout(timer); // Cleanup function to clear the timer
  }, []); // Empty dependency array means this effect runs once after the component mounts
  useEffect(() => {
    const track_id = "G-T6622GHTPT";
    ReactGA.initialize(track_id);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleHover = (index) => {
    setHoveredIndex(index);
  };

  const handleLeave = () => {
    setHoveredIndex(null);
  };
  const [itemsPerPage, setItemsPerPage] = useState(4);

  useEffect(() => {
    const updateItemsPerPage = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        setItemsPerPage(4);
      } else if (windowWidth >= 700) {
        setItemsPerPage(3);
      } else {
        setItemsPerPage(2);
      }
    };
    updateItemsPerPage();
    window.addEventListener("resize", updateItemsPerPage);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage);
    };
  }, []);

  const shouldEnableSlider = window.innerWidth < 700;
  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    slidesToShow: itemsPerPage,
    slidesToScroll: 1,
    className: "custom-slider",
  };

  return (
    <div className="home">
      <ScrollPage />
      <div className="homeContainer">
        <React.Fragment>
          <Dialog
            sx={{ zIndex: 99999999999999 }}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle
              sx={{
                fontFamily: "Poppins",
                fontSize: { lg: "18px", md: "16px", sm: "16px", xs: "15px" },
              }}
              className="dialogPromoTitle"
            >
              Bienvenue chez Ebuy
            </DialogTitle>

            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <a href="/bons-plans/">
              <DialogContent className="custom-dialog">
                <div className="promo-slider">
                 <Slider {...settings3}>
  {slides.map((slide, index) => {
    const link =
      slide === "14"
        ? `/produit/${slugify("maison & déco")}/${slugify("meubles")}/${slugify("meuble de rangement")}`
        : `/bons-plans/${encodeURIComponent(slide)}`;

    return (
      <div key={index}>
        <a href={link}>
          <img
            src={require(`../../images/promos/${slide}.jpg`)}
            alt={`Slide ${index + 1}`}
          />
        </a>
      </div>
    );
  })}
</Slider>
                </div>
              </DialogContent>
            </a>

            <DialogActions>
              <a href="/bons-plans">
                <Button
                  size="small"
                  color="warning"
                  sx={{ fontFamily: "Poppins" }}
                  onClick={handleClose}
                >
                  profiter!
                </Button>
              </a>
            </DialogActions>
          </Dialog>
        </React.Fragment>

        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={500} animation="wave" />
        ) : (
          <Carousel />
        )}
        {loading ? (
          <Skeleton variant="rectangular" width="90%" height={150} sx={{ margin: "20px auto" }} />
        ) : (
        <a href={ `/produit/${slugify("maison & déco")}/${slugify("meubles")}/${slugify("meuble de rangement")}` }   
          style={{
         
            textDecoration: "none" 
          }}>
  <div className="promoBand">
    <div className="promoBandInner">
      <div className="promoBandImgWrap">
        <span className="promoBandBadge">Promo</span>
        <img
          className="promoBandImg"
          src="https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/maison%20&%20d%C3%A9co%2Fmeubles%2Fmeubles%20meuble%20de%20rangement.jpeg?alt=media"
          alt="Meuble de rangement"
        />
      </div>
      <div className="promoBandInfo">
        <span className="promoBandCat">Maison &amp; Déco · Meubles</span>
        <span className="promoBandName">Meuble de rangement</span>
        <span className="promoBandDesc">Offre limitée — stocks réduits</span>
      </div>
      <div className="promoBandSep" />
      <div className="promoBandPrices">
        <span className="promoBandOld">70 DT</span>
        <span className="promoBandNew">55<span className="promoBandUnit"> DT</span></span>
        <span className="promoBandDiscount">-21%</span>
      </div>
      <div className="promoBandSpacer" />
      <Button
        className="promoBandBtn"
        endIcon={<ArrowRightAltIcon2 />}
        size="medium"
      >
        Profiter de l'offre
      </Button>
    </div>
  </div>
</a>)}
        {/*----------------vente flash----------------*/}
        <div style={{ marginTop: "40px" }}>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="rectangular" width="45%" height={300} />
              <Skeleton variant="rectangular" width="45%" height={300} />
            </div>
          ) : (
        <VenteFlash />
        )}
        </div>
        {/*----------------vente flash----------------*/}
        {/*----------------La sélection de la semaine----------------*/}
        <div style={{ marginTop: "40px" }}>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="rectangular" width="45%" height={300} />
              <Skeleton variant="rectangular" width="45%" height={300} />
            </div>
          ) : (
        <SelctionSemaine /> )}
        </div>
        {/*----------------La sélection des produits----------------*/}
        <div style={{ marginTop: "40px" }}>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="rectangular" width="45%" height={300} />
              <Skeleton variant="rectangular" width="45%" height={300} />
            </div>
          ) : (
        <SelectionProduct />)}
        </div>
        {/*----------------categorie----------------*/}
      <div className="catHome">
          {loading ? renderSkeletonCategories() : (
          <Slider {...settings2}>
            {categories.map((item) => (
              <div className={`images-zoom-container-home`}>
                <a href={`/collections/${item.link}`}>
                  <img
                    src={require(`../../images/categ/${item.img}.png`)}
                    alt={item}
                    className="catImgHome"
                  />
                </a>
              </div>
            ))}
          </Slider>
          )}
        </div>
        

        {/*----------------banniereHome----------------*/}
        <BanniereHome />
        {/*----------------nouveaté----------------*/}
        <NewHome />
        {/*----------------nouveaté----------------*/}
        <h2
          ref={ref1}
          style={{
            transform: isInView ? "none" : "translateY(200px)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
          className="bigTitleSlide2"
        >
          Nos Packs et promos
        </h2>
        <div
          ref={ref1}
          style={{
            transform: isInView ? "none" : "translateY(200px)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
          className="bonPlanHome"
        >
          <Slider {...settings1}>
            {itemData.map((item) => (
              <div className={`images-zoom-container-home`}>
                <a href={`/bons-plans/${item}`}>
                  <img
                    src={require(`../../images/promos/${item}.jpg`)}
                    alt={item}
                    className="promoImgHome"
                  />
                  <Button
                    endIcon={<ArrowRightAltIcon />}
                    color="warning"
                    className="promoButton"
                  >
                    Profiter
                  </Button>
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {/*----------------categorie+photos----------------*/}
      <div
        style={{
          backgroundColor: "#F0E7D8",
          marginTop: "10px",
          transform: isInView3 ? "none" : "translateY(200px)",
          opacity: isInView3 ? 1 : 0,
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
        ref={ref3}
      >
        {shouldEnableSlider && (
          <Slider {...settings} className="categSlider">
            <div
              className={`categDivAnimation ${
                hoveredIndex === 1 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(1)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("électroménager & cuisine")}`}>
                <img className="catImg" src={categ11} alt="" />
              </a>
              <h2>Simplicité et efficacité dans chaque foyer</h2>
              <p>
                Bienvenue dans notre gamme d'appareils électroménagers, où la
                simplicité rencontre l'efficacité. Nous nous engageons à rendre
                la vie quotidienne plus facile et plus agréable avec des
                produits de qualité.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 4 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(4)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("beaute & sante")}`}>
                <img className="catImg" src={categ44} alt="" />
              </a>
              <h2>Beauté & Soin : Excellence pour Elle et Lui</h2>
              <p>
                Découvrez notre gamme Beauté & Soin, avec un large choix
                d'appareils pour cheveux, corps et plus. Des solutions pratiques
                pour femmes et hommes, offrant qualité et performance pour une
                routine de soin parfaite.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 2 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(2)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("maison & déco")}/${slugify("luminaire")}`}>
                <img className="catImg" src={categ22} alt="" />
              </a>
              <h2>Illuminez votre style, Créez l’ambiance parfaite</h2>
              <p>
                Bienvenue dans notre univers lumineux. De suspensions
                sophistiquées à des lampes de table modernes, notre gamme de
                luminaires crée une ambiance unique dans chaque coin de votre
                maison.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 3 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(3)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("maison & déco")}/${slugify("meubles")}`}>
                <img className="catImg" src={categ33} alt="" />
              </a>
              <h2>
                Mobilier ingénieux : Style fonctionnel pour un quotidien
                simplifié
              </h2>
              <p>
                Explorez des solutions de rangement astucieuses, des meubles
                adaptables à vos besoins changeants, et des créations qui
                allient forme et fonction. Notre gamme de mobilier ingénieux
                vise à simplifier votre vie quotidienne tout en apportant une
                touche moderne et esthétique à votre intérieur.
              </p>
            </div>
          </Slider>
        )}

        {/* Afficher les divs individuellement sur grand écran */}
        {!shouldEnableSlider && (
          <div className="categDiv2">
            <div
              className={`categDivAnimation ${
                hoveredIndex === 1 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(1)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("électroménager & cuisine")}`}>
                <img className="catImg" src={categ11} alt="" />
              </a>
              <h2>Simplicité et efficacité dans chaque foyer</h2>
              <p>
                Bienvenue dans notre gamme d'appareils électroménagers, où la
                simplicité rencontre l'efficacité. Nous nous engageons à rendre
                la vie quotidienne plus facile et plus agréable avec des
                produits de qualité.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 4 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(4)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("beaute & sante")}`}>
                <img className="catImg" src={categ44} alt="" />
              </a>
              <h2>Beauté & Soin : Excellence pour Elle et Lui</h2>
              <p>
                Découvrez notre gamme Beauté & Soin, avec un large choix
                d'appareils pour cheveux, corps et plus. Des solutions pratiques
                pour femmes et hommes, offrant qualité et performance pour une
                routine de soin parfaite.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 2 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(2)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("maison & déco")}/${slugify("luminaire")}`}>
                <img className="catImg" src={categ22} alt="" />
              </a>
              <h2>Illuminez votre style, Créez l’ambiance parfaite</h2>
              <p>
                Bienvenue dans notre univers lumineux. De suspensions
                sophistiquées à des lampes de table modernes, notre gamme de
                luminaires crée une ambiance unique dans chaque coin de votre
                maison.
              </p>
            </div>
            <div
              className={`categDivAnimation ${
                hoveredIndex === 3 ? "hovered" : ""
              }`}
              onMouseEnter={() => handleHover(3)}
              onMouseLeave={handleLeave}
            >
              <a href={`/collections/${slugify("maison & déco")}/${slugify("meubles")}`}>
                <img className="catImg" src={categ33} alt="" />
              </a>
              <h2>
                Mobilier ingénieux : Style fonctionnel pour un quotidien
                simplifié
              </h2>
              <p>
                Explorez des solutions de rangement astucieuses, des meubles
                adaptables à vos besoins changeants, et des créations qui
                allient forme et fonction. Notre gamme de mobilier ingénieux
                vise à simplifier votre vie quotidienne tout en apportant une
                touche moderne et esthétique à votre intérieur.
              </p>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
const itemData = [
  "1","2","3","4","5","6","7","8","9","10","11"
];
const categories = [
  {
    img: "électroménager & cuisine",
    link: slugify("électroménager & cuisine"),
  },

  {
    img: "beaute & sante",
    link: `${slugify("informatique & lifestyle")}/${slugify("lifestyle")}/${slugify("beaute & sante")}`,
  },

  {
    img: "mode & accessoires",
    link: `${slugify("informatique & lifestyle")}/${slugify("lifestyle")}/${slugify("accessoires")}`,
  },

  {
    img: "informatique & gaming",
    link: `${slugify("informatique & lifestyle")}/${slugify("informatique")}`,
  },

  {
    img: "meubles",
    link: `${slugify("maison & déco")}/${slugify("meubles")}`,
  },

  {
    img: "luminaire",
    link: `${slugify("maison & déco")}/${slugify("luminaire")}`,
  },
];
  

 
  
const slides = [
"14","12","13"
];
export default Home;

